// extracted by mini-css-extract-plugin
export default {"paye-header":"Header_paye-header__9uirs","paye-header__buttons":"Header_paye-header__buttons__LW1sh"};